import { FileReader, FileWriter } from '@/platform'
import EventComment from '../EventClass/EventComment'
import { normalizeString, writeIntBool } from '../gameBinUtils'

enum controlType {
    Image = 0,
    String = 1,
    Var = 2,
    VarBar = 3,
    Oaf = 4,
}

class FloatButtonElementData {

    public Type: controlType = 0 //类型，0图片 1字符串 2变量
    public X: number = 0
    public Y: number = 0 //该元素的位置
    public Image: string = '' //若类型为0图片，且为直接指定图片的话，记录该图片名;若类型为4动态图片，记录文件名及选择的子动画列表
    public IsStrImage: boolean = false //若类型为0图片，记录是否为字符串指定的图片
    public IndexOfStr: number = 0 //若类型为0图片，且为字符串指定图片，记录字符串的索引，0起始
    public StrIndex: number = 0 //若类型为1字符串，记录字符串索引，0起始
    public VarIndex: number = 0 //若类型为2变量，记录变量索引，0起始
    public FontColor: string = '' //若类型为 1字符串 或 2变量，记录使用的颜色，形如"255,0,255"
    public eventList: Array<EventComment> = [] //事件列表

    constructor(param?: controlType) {
        if (typeof param === 'number') {
            this.Type = param
            this.X = 0
            this.Y = 0
            this.Image = ''
            this.IsStrImage = false
            this.IndexOfStr = 0
            this.StrIndex = 0
            this.VarIndex = 0
            if (this.Type === controlType.Oaf){
                this.FontColor = ''
            } else {
                this.FontColor = '0,0,0'
            }
        } else {
            // TODO 读取数据
        }
    }

    readBin(reader: FileReader): void {
        this.Type = reader.readInt()
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.Image = reader.readString()
        this.IsStrImage = reader.readBool()
        this.IndexOfStr = reader.readInt()
        this.StrIndex = reader.readInt()
        this.VarIndex = reader.readInt()
        this.FontColor = reader.readString()
        this.eventList = []
        const eventLen = reader.readInt()
        for (let index = 0; index < eventLen; index++) {
            const event = new EventComment()
            event.readBin(reader)
            this.eventList.push(event)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Type)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeString(this.Image)
        writer.writeBool(this.IsStrImage)
        writer.writeInt(this.IndexOfStr)
        writer.writeInt(this.StrIndex)
        writer.writeInt(this.VarIndex)
        writer.writeString(this.FontColor)
        writer.writeInt(this.eventList.length)
        for (let i = 0; i < this.eventList.length; i++) {
            this.eventList[i]!.writeBin(writer)
        }
    }

    writeGameBin(writer: FileWriter): void {
        writer.writeInt(this.Type)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeString(normalizeString(this.Image))
        writeIntBool(writer, this.IsStrImage)
        writer.writeInt(this.IndexOfStr)
        writer.writeInt(this.StrIndex)
        writer.writeInt(this.VarIndex)
        writer.writeString(normalizeString(this.FontColor))
    }
}

export default FloatButtonElementData
